export default {
	sec_10: {
		title: {
			one: 'Global payment ',
			two: 'processing',
		},
		desc: {
			one: 'Accept JP WOLRD Pay and withdraw to the',
			two: 'country of your choice.',
		},
		btn: {
			one: 'Sign up',
			two: 'Download App',
		},
	},
	sec_02: {
		title: {
			one: 'Automatically applied to ',
			two: 'current exchange rate',
		},
		desc: {
			one: 'Withdraw your funds whenever you want.',
		},
		step: {
			one: {
				one: 'Access JP WOLRD Pay ',
				two: 'via PC or mobile.',
			},
			two: {
				one: 'Fill your wallet with assets',
			},
			three: {
				one: 'You can invest or buy /??',
				two: 'wherever you want!',
			},
		},
	},
	sec_11: {
		one: {
			title: {
				one: 'JP WOLRD Pay customers can make payments',
				two: 'regardless of their country.',
			},
		},
		two: {
			title: {
				one: 'Why use cryptocurrency',
			},
			desc: {
				one: 'The best reason is that you only need to look at the number of exchange rates.',
			},
		},
	},
};
